import { HomeRegistrationFragment } from "@pathwright/graphql-client/src/generated"
import React from "react"
import { usePathwrightContext } from "../../pathwright/PathwrightContext"
import { PositionedObject } from "../../positioning/PositioningContext"
import { TipStatus } from "../../tips/types"
import useTipStatus from "../../tips/useTipStatus"
import { hasPathwrightStaffAccess } from "../../user/permissions"
import HomeSetAsidePathsTip from "./HomeSetAsidePathsTip"
import HomeWelcomeAllTransitionalBlankSlateTip from "./HomeWelcomeAllTransitionalBlankSlateTip"
import HomeWelcomeDesignerBlankSlateTip from "./HomeWelcomeDesignerBlankSlateTip"
import HomeWelcomeMemberBlankSlateTip from "./HomeWelcomeMemberBlankSlateTip"

type UseSuperUserHomeTipsProps = {
  registrations:
    | HomeRegistrationFragment[]
    | PositionedObject<HomeRegistrationFragment>[]
}

// For viewing Home tips regardless of conditions.
export function useSuperUserHomeTips({
  registrations
}: UseSuperUserHomeTipsProps) {
  const pwContext = usePathwrightContext()

  function getValue(status?: TipStatus) {
    return !!status && status !== "dismissed"
  }

  const tips: React.ReactElement[] = []
  if (hasPathwrightStaffAccess(pwContext)) {
    if (
      getValue(useTipStatus("home-welcome-all-transitional-blank-slate")[0])
    ) {
      tips.push(
        <HomeWelcomeAllTransitionalBlankSlateTip key="super-user-home-welcome-all-transitional-blank-slate" />
      )
    }
    if (getValue(useTipStatus("home-welcome-designer-blank-slate")[0])) {
      tips.push(
        <HomeWelcomeDesignerBlankSlateTip key="super-user-home-welcome-designer-blank-slate" />
      )
    }
    if (getValue(useTipStatus("home-welcome-member-blank-slate")[0])) {
      tips.push(
        <HomeWelcomeMemberBlankSlateTip key="super-user-home-welcome-member-blank-slate" />
      )
    }
    if (getValue(useTipStatus("home-set-aside-paths")[0])) {
      tips.push(
        <HomeSetAsidePathsTip
          key="super-user-home-set-aside-paths"
          inactiveRegistrations={registrations.slice(0, 2)}
        />
      )
    }
  }

  return tips
}

// For viewing Home tips regardless of conditions.
function SuperUserHomeTips({ registrations }: UseSuperUserHomeTipsProps) {
  const tips = useSuperUserHomeTips({ registrations })

  return (
    <>
      {tips.map((tip) => (
        <>{tip}</>
      ))}
    </>
  )
}

export default SuperUserHomeTips
